import { Helmet } from 'react-helmet-async';
import DefaultLayout from '../../../layouts/DefaultLayout';

const faqData = [
    {
        title: '1. Général',
        questions: [
            {
                question: 'Comment accéder au portail client ?',
                answer: 'Rendez-vous sur l’URL dédiée (ex. http://groupsil.ib1cloud.com:2030/), puis connectez-vous avec vos identifiants.',
            },
            {
                question: 'Comment contacter le support technique ?',
                answer: 'Envoyez un email à support@groupsil.com ou appelez le +243 85 69 78 123.',
            },
        ],
    },
    {
        title: '2. Prises carburants',
        questions: [
            {
                question: 'Que puis-je voir dans l’onglet Prises carburants ?',
                answer: 'Liste de toutes vos opérations de ravitaillement : date, station, volume, type de carburant et montant.',
            },
            {
                question: 'Comment filtrer mes prises par date ou station ?',
                answer: 'Utilisez les filtres en haut du tableau (date début/fin, station), puis cliquez sur « Appliquer ».',
            },
            {
                question: 'Que faire si une prise n’apparaît pas dans la liste ?',
                answer: 'Vérifiez les filtres appliqués et assurez-vous que la date de la prise est incluse dans la plage sélectionnée. Si le problème persiste, contactez le support technique.',
            },
            {
                question: 'Puis-je exporter mes prises de carburant ?',
                answer: 'Cliquez sur le bouton « Exporter » pour télécharger vos données.',
            },
        ],
    },
    {
        title: '3. Paiements',
        questions: [
            {
                question: 'Quelles infos dans l’onglet Paiements ?',
                answer: 'Historique de vos règlements : date, type (provision, crédit, ...), montant, statut, station, etc.',
            },
            {
                question: 'Puis-je exporter mes prises de carburant ?',
                answer: 'Cliquez sur le bouton « Exporter » pour télécharger vos données.',
            },
        ],
    },
    {
        title: '4. Cartes',
        questions: [
            {
                question: 'À quoi sert l’onglet Cartes ?',
                answer: 'Gérer vos cartes : activation/désactivation, recharge, etc.',
            },
            {
                question: 'Comment obtenir une nouvelle carte ?',
                answer: 'Pour obtenir une nouvelle carte, vous devez contacter le support.',
            },
            {
                question: 'Puis-je bloquer une carte perdue ou volée ?',
                answer: 'Sélectionnez la carte concernée et cliquez son statut en "Inactif" pour la désactiver immédiatement.',
            },
            {
                question: 'Comment recharger une carte ?',
                answer: 'Sélectionnez la carte dans l’onglet Cartes, puis cliquez sur "Recharge"',
            },
            {
                question: 'Comment vérifier le solde d’une carte ?',
                answer: 'Dans l’onglet Cartes, sélectionnez la carte concernée. Le solde actuel sera affiché dans les détails de la carte.',
            },
            {
                question: 'Que faire si une carte est verrouillée après plusieurs codes PIN incorrects ?',
                answer: 'Dans le menu "Cartes", vous pouvez accéder à la liste des cartes verrouillées via le sous-menu "Cartes verrouillées". Il vous suffit alors d\'ouvrir la carte concernée, puis d\'appuyer sur "Déverrouiller".',
            },
        ],
    },
    {
        title: '5. Autres fonctionnalités',
        questions: [
            {
                question: 'Comment modifier mes informations personnelles ?',
                answer: 'Allez dans votre profil (en haut à droite), cliquez sur « Mes informations » et mettez à jour vos coordonnées.',
            },
            {
                question: 'Comment signaler un bug ou un problème technique ?',
                answer: 'Envoyez un email à support@groupsil.com avec une description détaillée du problème.',
            },
        ],
    },
];

const FaqPage = () => {
    return (
        <>
            <Helmet>
                <title>FAQ :: Portail PETROSIL</title>
            </Helmet>

            <div className="page-wrapper">
                <div className="page-header d-print-none">
                    <div className="container-xl">
                        <div className="row g-2 align-items-center">
                            <div className="col">
                                <h2 className="page-title">Foire aux Questions</h2>
                            </div>
                            <div className="col-auto ms-auto d-print-none">
                                <div className="d-flex">
                                    <ol className="breadcrumb breadcrumb-arrows" aria-label="breadcrumbs">
                                        <li className="breadcrumb-item">
                                            <a href="/">Accueil</a>
                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page">
                                            <a href="#">FAQ</a>
                                        </li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="page-body">
                    <div className="container-xl">
                        <div className="card card-lg">
                            <div className="card-body">
                                <div className="space-y-4">
                                    {faqData.map((section, sectionIndex) => (
                                        <div key={sectionIndex}>
                                            <h2 className="mb-3">{section.title}</h2>
                                            <div id={`faq-${sectionIndex}`} className="accordion" role="tablist" aria-multiselectable="true">
                                                {section.questions.map((item, questionIndex) => (
                                                    <div className="accordion-item" key={questionIndex}>
                                                        <button className={`accordion-header collapsed`} data-bs-toggle="collapse" data-bs-target={`#faq-${sectionIndex}-${questionIndex}`} role="tab">
                                                            <h4 className="accordion-header-text">{item.question}</h4>
                                                        </button>
                                                        <div id={`faq-${sectionIndex}-${questionIndex}`} className={`accordion-collapse collapse`} role="tabpanel" data-bs-parent={`#faq-${sectionIndex}`}>
                                                            <div className="accordion-body pt-0">
                                                                <p>{item.answer}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

FaqPage.Layout = DefaultLayout;

export default FaqPage;
